var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.closed)?_c('Portal',{attrs:{"selector":"#modals"}},[(_vm.Overlay)?_c('div',{staticClass:"c-overlay",on:{"click":function($event){return _vm.$emit( 'Overlay' )}}}):_vm._e(),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }